import { render } from "./ClearUpList.vue?vue&type=template&id=3783e187"
import script from "./ClearUpList.vue?vue&type=script&lang=js"
export * from "./ClearUpList.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__